import { Component } from "react";
import { Icon } from "../Common.jsx";

export default class AdminPageBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("[AdminPageBoundary] caught error:", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <section style={{ padding: 32 }}>
        <div
          className="card"
          style={{
            padding: 32,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 12,
          }}
        >
          <div
            style={{
              width: 56, height: 56, borderRadius: 16,
              display: "grid", placeItems: "center",
              background: "rgba(239,68,68,0.15)", color: "#EF4444",
            }}
          >
            <Icon name="alert-triangle" size={28} />
          </div>
          <h2 style={{ margin: 0 }}>This page hit an error</h2>
          <p style={{ color: "var(--text-muted)", margin: 0, fontSize: 13, maxWidth: 420 }}>
            {this.state.error?.message || "Something went wrong while rendering this admin section."}
          </p>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn btn-ghost" onClick={() => window.location.reload()}>
              <Icon name="refresh-cw" size={14} /> Reload
            </button>
            <button className="btn btn-primary" onClick={this.reset}>
              Retry render
            </button>
          </div>
        </div>
      </section>
    );
  }
}
